import { render, staticRenderFns } from "./PEC_img2.vue?vue&type=template&id=e8399e5a"
import script from "./PEC_img2.vue?vue&type=script&lang=js"
export * from "./PEC_img2.vue?vue&type=script&lang=js"
import style0 from "./PEC_img2.vue?vue&type=style&index=0&id=e8399e5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports